// import axios from 'axios'
// import store from '../store/index'
// // import GLOBAL_CONFIG from '../../config/index'

// /**
//  * 描述：获取机构配置，需要读取公共配置、机构自定义配置、等级配置，优先级：机构自定义配置 > 等级配置 > 公共配置
// **/
// export const useOrgConfig = (dengerOrgInfo, orgId) => {
//     dengerOrgInfo = dengerOrgInfo || {}
//     const uId = store.getters['dsInfo/getUid'] || orgId
//     const fetchCommonConfig = axios.get(`https://tengfaceliveuser.tengface.net/web/config/miniConfig.json?ran=${new Date().valueOf()}`)
//     const fetchOrgConfig = axios.get(`https://tengfaceliveuser.tengface.net/web/config/userConfig/${uId}.json?a=${new Date().valueOf()}`)
//     return new Promise((resolve, reject) => {
//         // 请求后合并配置
//         Promise.allSettled([fetchCommonConfig, fetchOrgConfig]).then(res => {
//             try {
//                 let defaultConfig = {}
//                 let orgConfig = {}
//                 let levelConfig = {}
//                 if(res[0].status === 'fulfilled') {
//                     defaultConfig = res[0].value.data || {}
//                 }
//                 if(res[1].status === 'fulfilled') {
//                     orgConfig = res[1].value.data || {}
//                 }
//                 if(dengerOrgInfo.domain) {
//                     levelConfig.follow_web_url = dengerOrgInfo.domain
//                     levelConfig.wx_h5_url = dengerOrgInfo.domain
//                 }
//                 if(dengerOrgInfo.app_id) {
//                     levelConfig.mp_login_appid = dengerOrgInfo.app_id
//                     levelConfig.mp_1v1_login_appid = dengerOrgInfo.app_id
//                 }
//                 if(dengerOrgInfo.original_id) {
//                     levelConfig.mp_1v1_login_orgin_id = dengerOrgInfo.original_id
//                 }
//                 if(dengerOrgInfo.url) {
//                     levelConfig.wx_qrcode_webview_url = dengerOrgInfo.url
//                 }
//                 // 如果机构有自定义配置，则优先自定义配置，所以把机构放最后面，当机构自定的配置没有的时候，就读取公共配置
//                 const mergeConfig = { ...defaultConfig, ...levelConfig, ...orgConfig }
//                 console.log('useOrgConfig: ', mergeConfig)
//                 resolve(mergeConfig)
//             } catch (error) {
//                 reject({code: 0, data: error})
//             }
//         }).catch(err => {
//             reject(err)
//         })
//     })
// }

import axios from 'axios'
import tool from './Tools.js'

/**
 * 描述：获取机构配置改版，不再使用cos文件存储，统一存到后端，通过接口调用获取机构最终的公众号、域名、小程序配置等
**/

export const useOrgConfig = (uId) => {
    return new Promise((resolve, reject) => {
        axios.get(`https://tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com/uid/more/${uId}.json?a=${new Date().valueOf()}`).then(({ status, data }) => {
            if(status === 200) {
                resolve(data)
            } else {
                resolve({})
            }
        }).catch(err => {
            axios.post(`${tool.baseUrlShanhuLive()}/liveapi/api/init/qryTypeConfig`, `uid=${uId}`).then(({ data: { code, data } }) => {
                if(code === 200) {
                    resolve(data)
                } else {
                    resolve({})
                }
            })
        })
    })
}   